import { translate } from "@/main";

export default class SignallampContentConfig {
  // i18nがundefinedな状態で翻訳ロジックが走らないようにするためクラス作成
  public static lampColorItems() {
    return [
      { text: translate("message.red"), value: "red" },
      { text: translate("message.yellow"), value: "yellow" },
      { text: translate("message.green"), value: "green" },
      { text: translate("message.blue"), value: "blue" },
      { text: translate("message.white"), value: "white" },
      { text: translate("message.notSelected"), value: "undefined"},
    ]
  }
  public static lampNumberItems() {
    return [
      { text: "1", value: 1 },
      { text: "2", value: 2 },
      { text: "3", value: 3 },
      { text: "4", value: 4 },
    ]
  }
  public static sendDurationList() {
    return [
      { text: "10", value: 10 },
      { text: "30", value: 30 },
      { text: "60", value: 60 },
      { text: "120", value: 120 },
    ]
  }
}
